export default {
  'engagement_register_New': 'New', // 1
  'engagement_register_Total_Register_User': 'Total New Users', // 2
  'engagement_register_New_Register_Users': 'New Users', //3
  'engagement_register_Today': 'Today', // 4
  'engagement_register_This_Week': 'This Week',
  'engagement_register_This_Month': 'This Month',
  'engagement_register_Last_Year': 'Last Year',
  'engagement_register_SDLW': 'SDLW', // 5
  'engagement_register_SWLM': 'SWLM',
  'engagement_register_SMLY': 'SMLY',

  'engagement_register_legend_SDLW': 'Same Day Last Week', // 5
  'engagement_register_legend_SWLM': 'Same Week Last Month',
  'engagement_register_legend_SMLY': 'Same Month Last Year',


  'engagement_register_Register_Users_Country_Distribution': 'New Users Country Distribution', // 1
  'engagement_register_Register_Users_Channel_Distribution': 'New Users Channel Distribution', // 2
  'engagement_register_Register_Users_Media_Channel_Distribution': 'New Users Media Channel Distribution',
  'engagement_register_Register_Users_Platform_Distribution': 'New Users Platform Distribution',

  'engagement_register_Register_Users': 'New Users',

  // Country/Region/Zone Breakdown 模块
  'engagement_register_Country/Region/Zone_Breakdown': 'Country/Region/Zone Breakdown', // 1
  'engagement_register_Country': 'Country',
  'engagement_register_New_of_top_10_Countries': 'New of top 10 Countries',
  'engagement_register_Region': 'Region',
  'engagement_register_New_of_top_10_Regions': 'New of top 10 Regions',
  'engagement_register_Zone': 'Zone',
  'engagement_register_New_of_top_10_Zones': 'New of top 10 Zones',
  'engagement_register_Channel': 'Channel',
  'engagement_register_New_of_top_10_Channels': 'New of top 10 Channels',
  'engagement_register_Platform': 'Platform',
  'engagement_register_New_of_top_10_Platform': 'New of top 10 Platforms',

  // Country/System/Language Breakdown 模块
  'engagement_register_Country/System/Language_Breakdown': 'Country/System/Language Breakdown', // 1
  'engagement_register_System': 'Platform',
  'engagement_register_New_of_top_10_Systems': 'New of Platform',
  'engagement_register_Language': 'Language',
  'engagement_register_New_of_top_10_Languages': 'New of Language',


  'engagement_register_Share_Of_All': 'Share of All',
  'engagement_register_Sum_New': 'Sum New',

  'engagement_register_Sum_New_Role_Count': 'New Role Count', // 1
  'engagement_register_Sum_Total_New_Role_Counts': 'Total New Role Counts', //2
  'engagement_register_Role': 'Role',
  'engagement_register_Date': 'Date',
  'engagement_register': 'New',
}
